export const PRACTICE_TEST = [
    {
        id: 1,
        test_name: 'Assessment Test',
        topic_ids: [9],
        use_practice_test_id: true,
        practice_test_id: 1,
        requires_subscription: false
    },
    {
        id: 2,
        test_name: 'Mock Exam 1',
        use_practice_test_id: true,
        practice_test_id: 2,
        requires_subscription: true
    },
    {
        id: 3,
        test_name: 'Mock Exam 2',
        use_practice_test_id: true,
        practice_test_id: 3,
        requires_subscription: true
    },
    {
        id: 4,
        test_name: 'Practice Test 1',
        use_practice_test_id: true,
        practice_test_id: 4,
        requires_subscription: true
    },
    {
        id: 5,
        test_name: 'Practice Test 2',
        use_practice_test_id: true,
        practice_test_id: 5,
        requires_subscription: true
    },
    {
        id: 6,
        test_name: 'Practice Test 3',
        use_practice_test_id: true,
        practice_test_id: 6,
        requires_subscription: true
    },
    {
        id: 7,
        test_name: 'Practice Test 4',
        use_practice_test_id: true,
        practice_test_id: 7,
        requires_subscription: true
    }
];

export const APP_DOMAIN_LIST = [
    {
        id: 1,
        domain_name: 'System Management',
        chapters: [1],
        exam_weightage: 32,
        show_proficiency: true,
        icon: 'linux',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 2,
        domain_name: 'Services and User Management',
        chapters: [2],
        exam_weightage: 21,
        show_proficiency: true,
        icon: 'account-group',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 3,
        domain_name: 'Security',
        chapters: [3],
        exam_weightage: 19,
        show_proficiency: true,
        icon: 'shield-lock',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 4,
        domain_name: 'Automation, Orchestration, and Scripting',
        chapters: [4],
        exam_weightage: 19,
        show_proficiency: true,
        icon: 'script',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
    {
        id: 5,
        domain_name: 'Troubleshooting',
        chapters: [5],
        exam_weightage: 9,
        show_proficiency: true,
        icon: 'tools',
        requires_subscription: true,
        num_questions: 5,
        num_flashcards: 5,
        num_articles: 3,
    },
];

export const QUESTION_VERSION_OF_JSON = 1
